import ApiService from "../../services/ApiService";
import Logger from "../../services/Logger";
import { getContentLanguage } from "../../services/LangPrefs";

const CreatorCrossService = {
    getCrossStats: async () => {
        try {
            const stats = await ApiService.getData(`/cr/cross/stats`);
            return stats;
        } catch (error) {
            Logger.error("Error fetching cross stats:", error);
            throw error;
        }
    },

    getDraftCrossPuzzle: async (language = null) => {
        try {
            const lang = language || getContentLanguage() || 'english';
            const params = { language: lang };
            const draft = await ApiService.getData(`/cr/cross/draft`, params);
            return draft;
        } catch (error) {
            Logger.error("Error fetching draft crossword puzzle:", error);
            throw error;
        }
    },

    listCrosswordPuzzles: async (page = 0, pageSize = 10, sort = 'createdAt:desc', keyword = null, state = null, genreId = null, language = null, excludeDiscarded = true, excludeDisabled = true, tags = null) => {
        try {
            const lang = language || getContentLanguage() || 'english';
            const params = {
                page: page,
                pageSize: pageSize,
                sort: sort,
                language: lang,
                excludeDiscarded: excludeDiscarded
            };
            if (state !== 'DISCARDED' && state !== 'DISABLED') {
                params.excludeDisabled = excludeDisabled;
            }
            if (keyword) params.keyword = keyword;
            if (state) params.state = state;
            if (genreId) params.genreId = genreId;
            if (tags && Array.isArray(tags) && tags.length > 0) {
                params.tags = tags.map((t) => String(t).trim()).filter(Boolean).join(',');
            }
            const result = await ApiService.getData(`/cr/cross`, params);
            return result;
        } catch (error) {
            Logger.error("Error listing crossword puzzles:", error);
            throw error;
        }
    },

    createCrosswordPuzzle: async (language = null, isKids = false) => {
        try {
            const lang = language || getContentLanguage() || 'english';
            const body = { isKids: isKids };
            const url = `/cr/cross?language=${lang}`;
            const result = await ApiService.postData(url, body);
            return result;
        } catch (error) {
            Logger.error("Error creating crossword puzzle:", error);
            throw error;
        }
    },

    /**
     * Apply title hook for a crossword puzzle
     * @param {string} tplId - The puzzle template ID
     * @returns {Promise<Object>} Object containing response code
     */
    applyTitleHook: async (tplId) => {
        try {
            const result = await ApiService.putData(`/cr/cross/${tplId}/title-hook`);
            return result;
        } catch (error) {
            Logger.error(`Error applying title hook for puzzle ${tplId}:`, error);
            throw error;
        }
    },

    updateCrossState: async (crossId, state) => {
        try {
            const result = await ApiService.putData(`/cr/cross/${crossId}/state`, { state });
            return result;
        } catch (error) {
            Logger.error(`Error updating cross state for puzzle ${crossId}:`, error);
            throw error;
        }
    },

    getCrossTags: async (language = 'english', state = undefined) => {
        try {
            const params = { language };
            if (state != null && state !== '') {
                params.state = state;
            }
            const tags = await ApiService.getData("/cr/cross/tags", params);
            return Array.isArray(tags) ? tags : [];
        } catch (error) {
            Logger.error("Error fetching cross tags:", error);
            throw error;
        }
    }
};

export default CreatorCrossService;
